export default __webpack_public_path__ + "8c6ad6e935203622864d2c25cfb489ac.png";